import { make } from "vuex-pathify"
import MediaAPI from "@/api/media"

const state = () => {
  return {
    adAccountId: null,
    loading: false,
    images: [],
    videos: [],
  }
}

const actions = {
  clearModule({ commit }) {
    commit("CLEAR_MODULE")
  },

  loadImages({ commit, rootGetters, state }, force = false) {
    if (!state.images.length || force) {
      commit("SET_LOADING", true)

      const adAccountId = rootGetters["accounts/adAccountId"]

      return MediaAPI.getAdAccountImages(adAccountId)
        .then(response => {
          commit("SET_IMAGES", response)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    }
  },
  uploadImage({ rootGetters }, image) {
    const adAccountId = rootGetters["accounts/adAccountId"]

    return MediaAPI.uploadAdAccountImage(adAccountId, image)
  },
}

const getters = {
  ...make.getters(state),
}

const mutations = {
  ...make.mutations(state),
  CLEAR_MODULE(state) {
    state.adAccountId = null
    state.loading = false
    state.images = []
    state.videos = []
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
